export default __webpack_public_path__ + "static/media/slider3.8699bde6.png";